/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Container, Alert } from 'react-bootstrap';
import Head from 'next/head';

export default function HostAgreement() {
  return (
    <>
      <Head>
        <title>Skyhook: Host Terms and Agreement</title>
        <meta name="description" content="Skyhook's Host Terms and Agreement" />
      </Head>
      <div className="pt-3">
        <Container>
          <h1>Host Terms and Agreement</h1>
          <Alert variant="info">
            By using this website to market or sell your products or services,
            you agree to the Host Terms and Agreement.
          </Alert>

          <h2>About Skyhook</h2>

          <p>
            We act as a platform for you as a local adventure travel guide or
            Tour Operator to sell and market awesome adventure travel trips.
            When you use the Skyhook site to sell your trips, you accept the
            Host Terms and Agreement.
          </p>

          <h2>Overview</h2>
          <p>
            www.skyhookadventure.com and subdomains of it (‘the Website’, ‘the
            Service’) are operated by Skyhook Mountaineering Ltd (‘the
            publisher’ ‘we’, ‘ourselves’ or ‘us’). These Host Terms and
            Agreement (these terms) govern agreements between us and you; the
            individuals, companies and/or organisations using the website and
            services for commercial reasons, as a displayer and/or purchaser of
            customer quotes, listings, advertising and/or sponsorship (‘the
            supplier’, ‘you’, ‘your’). Submitting any information to the
            website, having an account and receiving enquiries, or submitting a
            reply or quote signifies acceptance of these Terms. In accepting
            these terms, you confirm you are authorised to do so on behalf of
            the company to which they refer.
          </p>

          <h2>Definitions</h2>

          <p>
            In this agreement, "Customer" or “enquirer” means the person(s) (or
            any of them) using this website, viewing, enquiring about, or using
            the goods and services provided by you or on your behalf. This will
            include but not be limited to 'travel arrangements' (accommodation,
            facilities, meals, entertainment, activities, equipment and other
            services (or any of them), as applicable). 'Information' refers to
            images, videos, text, data and any other media used for profiles,
            listings, newsletters, guides, blogs, advertising, shop, sponsorship
            and/or any other information provided by you to us.
          </p>

          <h2>Services</h2>

          <p>
            We will act as a travel agent for your trips, services and/or travel
            packages (‘Trip’, ‘Trips’).
          </p>

          <h2>Prices, Payment and Commission</h2>
          <h3>Setting the price</h3>
          <p>
            You will be given access to the Website, where you will be able to
            update the price that you receive for each Trip (the ‘Host Price’).
            You may adjust this price as you see fit, subject to any additional
            agreements that we may have in place. The price that a customer pays
            (the ‘Guest Price’) will be different to the Host Price allowing for
            our variable rate of commission (‘Commission’). The default rate of
            Commission is 20% for hosts legally registered outside the UK and
            24% for hosts legally registered inside the UK. You agree that we
            can adjust the Commission as we see fit with reasons including, but
            not limited by, sale pricing, customer discounts, customer credit
            spend, cancellations, and to allow for differences in currency
            exchange rates. You agree to authorise us to take the customer
            payments on your behalf, as your agent, and to deduct our Commission
            directly from these payments. You will then receive the price the
            Host Price that you had set, or we had set on your instruction,
            subject to the rest of this agreement.
          </p>

          <h3>Sales Tax and VAT</h3>

          <p>
            All fees and Commission exclude VAT or Sales Tax unless otherwise
            stated. It is your responsibility to comply with all relevant
            taxation requirements.
          </p>

          <h3>Deposits</h3>

          <p>
            You agree that we may offer customers an option to pay a deposit
            first, and pay the balance at a later date. Under these conditions
            our Commission will be deducted first unless otherwise stated.
          </p>

          <h3>Financial Protection and Pay-outs</h3>

          <p>
            When a customer pays for your trip, the amount of the Host Price
            will be placed in an independently managed trust fund (‘Trust
            Fund’), which may help you comply with package travel related
            regulations within your Country. After they travel, this will then
            be scheduled to be paid out to your nominated bank account within 40
            calendar days, subject to the rest of this agreement. You agree that
            we are not responsible for any fees or charges from your bank, as a
            result of these pay-outs.
          </p>

          <p>
            Bookings are financially protected by Trust My Travel. You also
            agree to their terms and conditions at&nbsp;
            <a href="https://trustprotects.me/terms/">
              https://trustprotects.me/terms/
            </a>{' '}
            .
          </p>

          <h3>Trust My Travel</h3>

          <p>
            <em>
              For&nbsp;bookings made after 10/10/2018, payments will be
              processed with our third party payment provider, Trust My Travel:
            </em>
          </p>

          <h3>Cancellations</h3>

          <p>
            You agree to adopt our standard cancellation terms and conditions
            for any customers who book through Us, as your agent. You can see
            the latest version of these customer terms and conditions on the
            Website. Should a customer cancel their trip two months or more
            before their trip start date, the Host will not receive any payment
            of the Host Amount. Should a customer cancel within 2 months (minus
            a 7-day grace period) of their trip, the host will ordinarily
            receive the full Host Amount unless alternative agreement is reached
            between Skyhook and the Host.
          </p>

          <p>
            If you have been given the option to set a non-refundable permit
            cost on a specific trip, then for that trip only you will ordinarily
            also receive this amount if the customer cancels more than 2 months
            before the start date.
          </p>

          <p>
            You agree that Skyhook may offer date changes, adjustments, refunds
            or cancellations to customers for their bookings with you outside of
            these standard terms where it, at it's sole discretion, deems it
            necessary to do so.
          </p>

          <h3>Refunds and Chargebacks</h3>

          <p>
            Should you cancel the Trip (for whatever reason), or the Trip is
            materially different from the way described, the customer may
            request a partial or full refund, or dispute a payment using e.g. a
            chargeback scheme. Within the EU-region and the UK, this may include
            a request under statutory rights, such as those under The Package
            Travel and Linked Travel Arrangements Regulations 2018. We will
            analyse any request and require a response from yourself within 5
            working days should this happen. Where we have taken payments as
            your agent, you agree that We have your authority to act as
            adjudicator for such disputes and issue any refunds or accept
            disputed card payments on your behalf.
          </p>

          <p>
            In the event of a full refund being processed for a customer upon
            cancellation by the Host for watever reason, or if a chargeback is
            received in relation to a booking, the Host will remain liable to
            pay the Commission due to Skyhook; as this cannot be deducted
            directly from the Guest Price paid by the Guest in this instance,
            Skyhook may either invoice the host separately for the Commission,
            or adjust future payouts to the host to collect the Commission owed.
          </p>

          <p>
            Chargebacks may be received in relation to a customer booking at any
            time. In the event of a chargeback being received after a trip has
            gone ahead, the Host Amount will no longer be payable to the Host
            and the Host will be liable for the amount of the chargeback. In the
            event that a trip is yet to go ahead, the booking relating to the
            chargeback will be cancelled and the Host will no longer be eligible
            to receive the Host Amount.
            <br />
            Skyhook reserves the right to pass on any chargeback related fees to
            the Host where Skyhook, at its sole discression, deems that the
            Customer is justified in having created a chargeback or if the Host
            has acted in any way improperly (which may have resulted in the
            chargeback). Additionally, Skyhook reserves the right to impose an
            additional administration fee (up the value of the disputed booking
            or £250 - whichever is higher) on the Host for handling chargebacks
            where Skyhook deems the Host to have acted improperly.
          </p>
          <h2>Liability</h2>

          <p>
            Suppliers accept all responsibility and liability for their holidays
            and for their customers and agree that we have no liability. We
            accept no liability whatsoever for any activity or behaviour of any
            persons who have used the site, made an enquiry through the site or
            for any behaviour or activity of persons booking and staying with
            members. We accept no liability for any of the information supplied
            to us by suppliers for publishing on the site(s). As far as is
            permissible by applicable law, we accept no liability for any loss
            however caused through omission from the web site, typographical
            errors or late publication or failure from any cause, whether error,
            technical, late publication or failure to display listings,
            advertising and/or sponsorship. In any event, our liability for any
            loss or damage whether caused by negligence or otherwise will be
            limited to the cost of any listings, advertising and/or sponsorship
            and we will not be liable for any consequential loss or damage or
            loss of profit of the purchaser or of any other party nor be liable
            for any other loss however suffered. You agree to indemnify us
            against all losses, damages, claims or expenses (including legal
            costs), which we may reasonably incur, on account of any claim by a
            third party arising directly or indirectly from the information
            provided by you for listings, advertising and/or sponsorship, or
            from the activities, mal-practice or negligence of you, the
            supplier. This may include, but is not limited to, claims that any
            information provided by you, the supplier, is in anyway misleading,
            inaccurate, libellous and/or offensive, and any action for breach of
            contract, and/or any tortious action.
          </p>

          <h2>Information, Images and Media</h2>

          <p>
            Suppliers agree that it is their responsibility to submit
            information and check that all information is accurate, up to date,
            and complete. You specifically agree it is your responsibility to
            ensure the accuracy of price and availability information displayed
            to customers about your products and services. You confirm you will
            accept bookings for your products and services at the price you most
            recently submitted to the site by any means. It is illegal to
            provide false or misleading pricing information. We may wish to use
            information and images for marketing your goods and services and
            generating new customer enquiries other than just on this website.
            We will always undertake to gain your prior approval about any new
            marketing partnerships. Nevertheless, you agree that all information
            and images provided to us can be used in other forms of marketing,
            on other websites owned by us, and provided to external websites not
            owned by Us at our discretion, only when expressly connected to your
            product, without prior approval. In circumstances where we believe
            information or an image might be useful in more generic ways, we
            will undertake to gain your prior approval. Information is accepted
            on the understanding that any descriptions of goods, services, stock
            etc. are accurate and comply with English law and the Trade
            Description Act 1968. You warrant that you own or control all rights
            or have obtained copyright, moral rights and similar permissions,
            consents, waivers as are required for the display of logos and
            trademarks in copy provided to us. We reserve the right to approve,
            amend or decline copy at our sole discretion and without
            explanation. We also reserve the right to change the layout of
            supplier pages, the information that is displayed, and the look and
            feel of the site as we deem appropriate and without notice.
          </p>

          <h2>Capacity and Availability</h2>

          <p>
            Once a trip is listed on the Skyhook website, it must go ahead
            without requiring a minumum number of bookings. Exceptions to this
            requirement must be granted in writing by Skyhook.
          </p>

          <h2>Privacy Protection</h2>

          <p>
            When bookings are made, we share personal information about the
            customer with you, in order for you to fulfil the booking. This
            information may also be shared over email. The information includes
            names, addresses, contact details and other personal information you
            may require, including medical and dietary requirements and travel
            plans. Where the customer is an EU citizen, you are required to
            handle this personal information in accordance with the General Data
            Protection Regulation ((EU) 2016/679) (GDPR) and any implementing
            legislation (Data Protection Legislation). This includes keeping any
            information we share with you confidential, stored securely and only
            for as long as is necessary; and to use the data only for the
            purpose it was intended – for managing the booking and delivering
            the services required. You agree not to contact the customer for any
            other purpose, unless they have subsequently given you explicit
            consent directly. You will not share the information with any other
            third parties, expect where essential for the purpose of managing a
            booking and delivering the services. In these circumstances, you
            require these third parties to also handle the information in
            accordance with the General Data Protection Regulation ((EU)
            2016/679) (GDPR) and any implementing legislation (Data Protection
            Legislation).
          </p>

          <h2>Communication</h2>

          <p>
            All communication with your guests, before and after the trip, must
            be done via the Skyhook messaging system. The only exception is if
            you have an emergency, or need to get urgent information, in which
            case you may use the phone number provided.
          </p>

          <p>
            You agree not to send any marketing communication to customers who
            have booked through Skyhook. This includes links to social media
            pages (e.g. Facebook pages), or links to your website. You also
            agree not to request reviews on any other platforms (e.g.
            Trustpilot), than the Skyhook website.
          </p>

          <h2>Termination</h2>

          <p>
            Both parties reserve the right to terminate this agreement at any
            time without a notice period. Any bookings taken before termination
            will be honoured by the Host unless express consent is given by
            Skyhook to waive this requirement; the conduct of both parties in
            respect of these bookings will be regulated according to the terms
            of this agreement.
          </p>
        </Container>
      </div>
    </>
  );
}
